import React from 'react';
import InputWrapper from './InputWrapper';

const DecimalInput = ({ field, fieldId, value, onChange, label, isRequired, error }) => {
  return (
    <InputWrapper field={field} label={label} isRequired={isRequired} error={error}>
      <input
        type="number"
        className="profile-input form-input"
        value={value}
        onChange={e => onChange(fieldId, parseFloat(e.target.value) || 0)}
        min={field.min || undefined}
        max={field.max || undefined}
        step="0.01"
        disabled={field.readOnly || false}
      />
    </InputWrapper>
  );
};

export default DecimalInput;

